/**
 * Portal Manta · featuresDoLote
 * Extraído de App.jsx v29.3 (via AST)
 */
import React, { useState, useEffect, useMemo, useCallback, Fragment, memo } from 'react';
import { BANCO_CHUVA_UF } from '../../data/banco-chuva-uf.js';
import { DADOS } from '../../data/lotes-pr.js';
import { CONSOL_FIN } from '../../data/consol-fin.js';
import { sumBy, isAmpliacao, OBRAS_ROD } from '../../globals.js';
import { META_OFICIAL } from '../../app-globals.js';

function featuresDoLote(sig){
  const dados = DADOS[sig] || {};
  const od = OBRAS_ROD[sig] || {};
  const cf = CONSOL_FIN[sig] || {};
  const dm = (dados.dados_manta||{}).compara_parametrico||{};
  const itens = (dm.itens||[]).filter(isAmpliacao);
  const ext = parseFloat((dados.extensao||'').replace(/[^\d,.]/g,'').replace(',','.')) || 0;
  const dupKm  = sumBy(od.duplicacoes||[],'km') + sumBy(od.contornos||[],'km');
  const margKm = sumBy(od.marginais||[],'km');
  const fxKm   = sumBy(od.faixas||[],'km');
  const ciclKm = sumBy(od.ciclovias||[],'km');
  const oaeQt  = sumBy(od.oaes||[],'n');
  const passQt = sumBy(od.passarelas||[],'n');
  const interQt = sumBy(od.diamantes||[],'n')+sumBy(od.trombetas||[],'n')+sumBy(od.parclos||[],'n')+sumBy(od.rotatorias||[],'n');
  const pu = {};
  pu.dup   = (itens.find(i=>i.codigo==='1.2.1')?.pr_vias?.preco_total||0) / Math.max(dupKm, 1);
  pu.marg  = (itens.find(i=>i.codigo==='1.2.2')?.pr_vias?.preco_total||0) / Math.max(margKm, 1);
  pu.inter = (itens.find(i=>i.codigo==='1.2.3')?.pr_vias?.preco_total||0) / Math.max(interQt, 1);
  pu.fx    = (itens.find(i=>i.codigo==='1.2.5')?.pr_vias?.preco_total||0) / Math.max(fxKm, 1);
  pu.cicl  = (itens.find(i=>i.codigo==='1.2.7')?.pr_vias?.preco_total||0) / Math.max(ciclKm, 1);
  pu.oae   = (itens.find(i=>i.codigo==='1.2.9')?.pr_vias?.preco_total||0) / Math.max(oaeQt, 1);
  pu.pass  = (itens.find(i=>i.codigo==='1.2.10')?.pr_vias?.preco_total||0) / Math.max(passQt, 1);
  const sicroTotal = Object.values(cf).reduce((s,a)=>s+sumBy(a,'v'),0);
  pu.sicroPorKm = ext>0 ? sicroTotal/ext : 0;
  const meta = META_OFICIAL[sig] || {uf:'PR',cidade:'',ctxRural:.5,ctxUrbano:.3,ctxSerra:.2};
  const chuva = BANCO_CHUVA_UF[meta.uf] || {mm:1500,dias:100,regime:'Regular'};
  return {
    sig, nome: dados.nome || `Lote ${sig}`, sigla: dados.sigla || `L${sig}`, fonte:'oficial',
    ext, dupKm, margKm, fxKm, ciclKm, oaeQt, passQt, interQt, sicroTotal,
    densDup: ext>0?dupKm/ext:0, densMarg: ext>0?margKm/ext:0, densCicl: ext>0?ciclKm/ext:0,
    densOae: ext>0?oaeQt/ext:0, densInter: ext>0?interQt/ext:0,
    pu, uf: meta.uf, regiao: UF_REGIAO[meta.uf]||'Sul', cidade: meta.cidade,
    ctxRural: meta.ctxRural, ctxUrbano: meta.ctxUrbano, ctxSerra: meta.ctxSerra,
    chuvaMM: chuva.mm, chuvaDias: chuva.dias, chuvaRegime: chuva.regime,
  };
}

export { featuresDoLote };
export default featuresDoLote;
